/**
 * Absolute URL builders for the routes defined in `router.tsx`.
 *
 * Navigation targets inside the space tree are built from ids rather than as
 * relative paths on purpose. Components like ProjectMenu render at more than
 * one depth in the route tree (ProjectPage and the drawer), and no single
 * relative base is correct for every render site — a `./x` link that works from
 * one lands on a non-existent URL from the other. Absolute paths are also
 * immune to route-tree reshaping, which is what broke these links during the
 * react-router v8 upgrade.
 */

export type ProjectTab =
  | 'documents'
  | 'tasks'
  | 'calendar'
  | 'share-links'
  | 'settings'
  | 'storyboards'
  | 'crew'
  | 'locations'
  | 'characters';

export const spacePath = (spaceId: string): string => `/space/${spaceId}`;

export const projectPath = (spaceId: string, projectId: string): string =>
  `${spacePath(spaceId)}/projects/${projectId}`;

export const projectTabPath = (spaceId: string, projectId: string, tab: ProjectTab): string =>
  `${projectPath(spaceId, projectId)}/${tab}`;
